import { render } from "./otherPublication.vue?vue&type=template&id=08d88daa&scoped=true"
import script from "./otherPublication.vue?vue&type=script&lang=js"
export * from "./otherPublication.vue?vue&type=script&lang=js"

import "./otherPublication.vue?vue&type=style&index=0&id=08d88daa&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d88daa"]])

export default __exports__